import { Eye } from 'lucide-react';

/** Shown above the page content when the signed-in staff member's section
 *  level is 'view' — a visible, non-blocking reminder that mutating actions
 *  on this page will be refused server-side even if the UI doesn't disable
 *  them all. */
export function ViewOnlyBanner() {
  return (
    <div className="mb-3 px-3 py-2 rounded-lg bg-sky-50 border border-sky-200 text-sky-900 text-sm flex items-center gap-2">
      <Eye size={16} className="shrink-0" /> View only — changes are disabled for your role.
    </div>
  );
}
